import * as React from "react";
const SvgFiRrToilet = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19 9.625V5h1a1 1 0 1 0 0-2h-1.126A4.006 4.006 0 0 0 15 0H9C6.794 0 5 1.794 5 4v5.625c-1.273.76-2 1.926-2 2.875 0 2.736 2.342 6.66 7.335 7.383C9.856 21 8.5 21 8.5 21a1.5 1.5 0 0 0 0 3h7a1.5 1.5 0 0 0 0-3s-1.356 0-1.835-1.117C18.658 19.16 21 15.236 21 12.5c0-.948-.727-2.115-2-2.875M9 2h6c1.103 0 2 .897 2 2v5.032L7 9.001V4c0-1.103.897-2 2-2m3 16c-2.761 0-4.621-1.116-5.725-2.436C7.923 15.943 9.992 16 12 16s4.077-.058 5.725-.436C16.621 16.884 14.761 18 12 18m0-4c-4.643 0-6.999-.505-7-1.498.008-.276.575-1.131 1.806-1.502h10.389c1.229.371 1.798 1.226 1.806 1.5 0 .995-2.355 1.5-7 1.5z"
    />
  </svg>
);
export default SvgFiRrToilet;
